
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef, useEffect, useState, useMemo } from "react";

// porp-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

import Map from "components/Maps/Map";

import Card from "@mui/material/Card";

import { Link, useNavigate } from 'react-router-dom';

import { useSoftUIController } from "hooks/context";

function ClearwaysGroupCard({ group, subgroup = null }) {
  const navigate = useNavigate();

  const [controller] = useSoftUIController();
  const { deviceLayout, userPermissions } = controller;

  const showAdvancedDeviceLevel = userPermissions.indexOf('devices-advanced:view') >= 0;
  const used_group = subgroup != null ? subgroup : group;


  const group_devices = used_group.devices.filter(d => d.active);

  const mapbox_settings = {
    style: 'mapbox://styles/harrymontano/cm01omrnz000u01omf2uegk93?optimize=true',
    zoom: 17,
    interactive: false
  }

  const onSubgroupClick = function (group, e) {
    let path = '/clearways/groups/' + group.group_id + '/subgroups';
    navigate(path);
    e.stopPropagation();
  }

  return (
    <Link to={'/clearways/groups/' + used_group.group_id} style={{ textDecoration: 'none' }}>
      <Card /*onClick={() => onEventClick(group)}*/ sx={{ cursor: 'pointer' }}>
        <SoftBox p={2}>
          <SoftBox display="flex" alignItems="center">
            <SoftBox lineHeight={0}>
              <SoftBox mb={1} lineHeight={0}>
                <SoftTypography variant="h6" textTransform="capitalize" fontWeight="medium">
                  {used_group.name}
                </SoftTypography>
              </SoftBox>
            </SoftBox>
          </SoftBox>
          <SoftBox display='flex' flexDirection='row' justifyContent='space-between'>
            <SoftBox lineHeight={1} mb={2}>
              {group_devices.length == 1 ? (
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  {group_devices.length + " Active Device"}
                </SoftTypography>
              ) : (
                <SoftTypography variant="button" fontWeight="regular" color="text">
                  {group_devices.length + " Active Devices"}
                </SoftTypography>
              )}
            </SoftBox>
            {(typeof used_group.subgroups != 'undefined' && used_group.subgroups.length > 0) && (
              <SoftBox>
                <SoftTypography onClick={(e) => { e.preventDefault(); onSubgroupClick(group, e) }} variant="button" fontWeight="regular" color="text">
                  {"View " + group.subgroups.length + " Subgroups"}
                </SoftTypography>
              </SoftBox>
            )}
          </SoftBox>
          <Card sx={{ height: '200px' }} onClick={(e) => { e.stopPropagation() }}>
            <Map selected_group={used_group} parent_group={subgroup == null ? {} : group} settings={mapbox_settings} padding={30} />
          </Card>
        </SoftBox>
      </Card>
    </Link>
  );

}

// Typechecking props for the ClearwaysGroupCard
ClearwaysGroupCard.propTypes = {
  group: PropTypes.object,
  subgroup: PropTypes.object
};

export default ClearwaysGroupCard;
